export const MarkupTypeCodes = {
  ABSOLUTE: 'A',
  FIXED: 'F',
  RELATIVE: 'R',
}
